/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Sync_To_JoorInputs */

const en_field_sync_to_joor = /** @type {(inputs: Field_Sync_To_JoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joor`)
};

/**
* | output |
* | --- |
* | "Joor" |
*
* @param {Field_Sync_To_JoorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_sync_to_joor = /** @type {((inputs?: Field_Sync_To_JoorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Sync_To_JoorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_sync_to_joor(inputs)
});